export default "__VITE_ASSET__zLTU$Q52__"